import React from 'react';
// eslint-disable-next-line no-unused-vars
import ModelCheck from '../model/ModelCheck';

const ResultAnalysis = (props) => {
    const isMobile = window.innerWidth < 768
    /** @type {ModelCheck} */
    const check = props.data

    const colors = { red: "#ED5A5A", green: "#DEFE71", blue: "#52A3FF", grey: "#777"}


    function getTextColor(text) {
        if (text.toLowerCase().includes("passed")) return "#DEFE71"
        else if (text.toLowerCase().includes("fail")) return "#ED5A5A"
        else if (text.toLowerCase() === "na") return colors.grey
        else if (parseInt(text) === 0) return colors.green
        else if (parseInt(text) > 0) return colors.red
        else return "#52A3FF"
    }


    return (
        <div className='card'>
            <h5 style={{marginBottom: 25}}>Result Analysis</h5>

            {
                check.analyticsWebview.map((e, index) => {
                    return (
                        <div className='flex-spaced' key={index} style={{marginBlock: 10}}>
                            <span>{ e.field }</span>
                            <span style={{color: getTextColor(e.value), fontWeight: 900, fontStyle: "italic"}}>{ e.value.toUpperCase() }</span>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default ResultAnalysis